import * as React from 'react';

const SvgWineGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={54} height={54} fill="none" {...props}>
    <path
      d="M20.25 50.22h13.5M27 50.22V31.452"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M42.496 14.076c.852 5.322-1.322 10.676-5.702 14.04v0c-5.726 4.398-13.862 4.398-19.588 0v0c-4.38-3.364-6.554-8.718-5.702-14.04l1.771-11.083c.127-.791.837-1.375 1.672-1.373h24.106c.833 0 1.54.583 1.668 1.373l1.775 11.083z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.432 14.58h31.136"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgWineGlass;
